import React from 'react';

const ResponsiveLogo = ({ alt = 'CITNC Logo', className = '' }) => {
  return (
    <>
      <img
        src="/citnc-portrait.png"
        alt={alt}
        className={`md:hidden w-auto object-contain ${className}`.trim()}
      />
      <img
        src="/citnc-landscape.png"
        alt={alt}
        className={`hidden md:block w-auto object-contain ${className}`.trim()}
      />
    </>
  );
};

export default ResponsiveLogo;